var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preformAction"},[_c('i',[_vm._v("*")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.t('自动确认退货(仓库回传退货入库结果后，系统自动完成退货确认的业务操作)')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }